export type ListingTypeOptions =
  | "Treatment"
  | "Package"
  | "Membership"
  | "Product"
  | "ProductFromExternalSource"
  | "GiftCard";

export const convertListingTypeToProductType = (
  type: ListingTypeOptions
): string => {
  switch (type) {
    case "Membership":
      return "membership";
    case "Package":
      return "product bundle";
    case "Treatment":
      return "treatment";
    case "Product":
    default:
      return "product";
  }
};

export const convertProductTypeToListingType = (
  productType: string
): ListingTypeOptions => {
  switch (productType) {
    case "treatment":
      return "Treatment";
    case "product bundle":
      return "Package";
    case "membership":
      return "Membership";
    case "product":
    default:
      return "Product";
  }
};
